<template>
  <div class="app-root">
    <AppTopbar :show="showTopBar" @onClose="() => (showTopBar = !showTopBar)" />
    <router-view />
  </div>
</template>

<script>
const AppTopbar = () => import("@/components/AppTopbar");

export default {
  name: "AppRoot",
  components: {
    AppTopbar
  },
  data() {
    return {
      theme: this.$store.state.app.scheme,
      showTopBar: false
    };
  },
  async created() {
    this.$store.dispatch("fetchScheme").then(scheme => {
      const data = scheme.status ? scheme.data[0].value : scheme;
      this.theme = data;
    });

    this.$socket.on("tenant:SendSetScheme", payload => {
      this.showTopBar = true;
      this.$store.dispatch("updateScheme", payload);
    });
  }
};
</script>

<style lang="scss">
.dropdown-menu {
  max-height: 320px !important;
  li {
    a {
      color: $gray-900 !important;
      font-size: $font-size-xs !important;
      &:hover {
        color: #fff !important;
      }
    }
    &:hover {
      color: #fff !important;
    }
  }
}
.datepicker {
  .calendar-days a {
    font-family: "Gotham Book" !important;
    font-size: $font-size-xs !important;
  }
  .calendar-date {
    &.calendar-date-selected {
      color: #fff;
      background-color: $gray-600;
      transition: all 0.2s ease;
      &:hover {
        background: $gray-800;
      }
    }
    &:hover {
      color: #fff !important;
      background: $gray-800 !important;
    }
  }
}
</style>
